/* src/app/modules/institutions/institutions-events/institutions-events.component.scss */
form {
  margin-bottom: 16px;
}
.cw-button-wrapper {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 16px;
}
#submodule-events .cw-submodule {
  margin-bottom: 20px;
}
#submodule-events .cw-flex-row {
  align-items: center;
  margin-bottom: 16px;
}
/*# sourceMappingURL=institutions-events.component.css.map */
